export const TrustedBarChartIcon = () => {
  return (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="4" width="48" height="48" rx="24" fill="#E6F2E8" />
      <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F4F9F4" strokeWidth="8" />
      <path
        d="M34 36V26M28 36V20M22 36V30"
        stroke="url(#paint0_linear_1_27086)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_27086"
          x1="28"
          y1="20"
          x2="28"
          y2="36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#119822" />
          <stop offset="1" stopColor="#06320B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
